export default "__VITE_ASSET__DIfaQySb__"